<template>
  <v-menu
    v-model="rejectReasonMenu"
    top
    nudge-left="24px"
    nudge-bottom="12px"
    offset-overflow
    :close-on-content-click="false"
    content-class="rejection-section"
    :disabled="isShowIntro2"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom :disabled="!commentOnlyAccess" max-width="15rem">
        <template v-slot:activator="{ on: tooltip }">
          <div class="position-relative z-10" v-bind="attrs" v-on="tooltip">
            <Button
              variant="danger2"
              :disabled="commentOnlyAccess || isShowIntro2 || loading"
              :loading="loadingAction === 'reject' && loading"
              v-on="menu"
            >
              <div
                class="tw-flex tw-gap-3 tw-items-center tw-px-8 tw-justify-center tw-min-w-[210px] tw-text-base"
              >
                <div>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-stroke-white"
                  >
                    <path
                      d="M14.6665 1.66699V10.8337M18.8332 8.16699V4.33366C18.8332 3.40024 18.8332 2.93353 18.6516 2.57701C18.4918 2.2634 18.2368 2.00844 17.9232 1.84865C17.5667 1.66699 17.1 1.66699 16.1665 1.66699H7.26489C6.04699 1.66699 5.43804 1.66699 4.9462 1.88985C4.51271 2.08627 4.1443 2.40234 3.88425 2.80092C3.58919 3.25315 3.49659 3.85502 3.3114 5.05876L2.87551 7.8921C2.63125 9.47975 2.50912 10.2736 2.74472 10.8913C2.9515 11.4334 3.34042 11.8867 3.84482 12.1735C4.41949 12.5003 5.22266 12.5003 6.82899 12.5003H7.49988C7.96659 12.5003 8.19995 12.5003 8.37821 12.5912C8.53501 12.671 8.66249 12.7985 8.74239 12.9553C8.83321 13.1336 8.83321 13.3669 8.83321 13.8337V16.2788C8.83321 17.4137 9.75321 18.3337 10.8881 18.3337C11.1588 18.3337 11.4041 18.1742 11.514 17.9269L14.3146 11.6255C14.442 11.3389 14.5057 11.1956 14.6064 11.0905C14.6954 10.9976 14.8047 10.9266 14.9257 10.883C15.0626 10.8337 15.2194 10.8337 15.533 10.8337H16.1665C17.1 10.8337 17.5667 10.8337 17.9232 10.652C18.2368 10.4922 18.4918 10.2372 18.6516 9.92364C18.8332 9.56712 18.8332 9.10041 18.8332 8.16699Z"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>Reject</div>
              </div>
            </Button>

            <HotSpot
              v-if="isShowIntro && isFront && iscurrentGolive"
              title="Reject"
              :contents="[...contents[1]]"
              :value="introStep"
              :hideClose="true"
              :isTooltip="true"
              :showDefault="isFront && iscurrentGolive"
              @close="$emit('closeHandler')"
              @prev="$emit('changeIntroStep', 0)"
            />
            <div v-if="isShowIntro2" class="rejected-flashing">
              <FlashingButton
                :contents="contents2"
                title="Reject Candidate"
                content-class="rejected-position rejected-position-left"
                bottom
                leftClass="reject-hotspot"
                :showFakeCard="showFakeCard"
                @close="$emit('closeInfo')"
              />
            </div>
          </div>
        </template>
        <span>You don't have permissions to perform this action</span>
      </v-tooltip>
    </template>
    <div
      class="tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-shadow-2 tw-max-h-screen tw-overflow-auto"
    >
      <Typography variant="headline-6" class="tw-pb-2">
        Why do you reject {{ candidate.name }}?
      </Typography>
      <Typography variant="body-2">
        After rejection, Hirefly will notify the candidate without sharing your
        reason or notes.
      </Typography>
      <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-6">
        <div v-for="(item, index) in reasonTypes" :key="`ReasonGroup-${index}`">
          <Typography variant="subtitle-2">{{ item.title }}</Typography>

          <div>
            <div
              v-for="(reasonRadio, index1) in item.reasons"
              :key="`Reason-${index1}`"
              class="tw-relative tw-mt-2"
            >
              <v-menu
                v-if="reasonRadio.key === '1'"
                :close-on-content-click="false"
                bottom
                nudge-bottom="35px"
                @input="onClickReasonRadio($event, reasonRadio.key)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="tw-flex tw-items-center tw-cursor-pointer">
                    <div>
                      <v-checkbox
                        v-model="selectedReason"
                        :value="reasonRadio.key"
                        hide-details
                      />
                    </div>
                    <div v-bind="attrs" v-on="on">
                      <Typography variant="body-2">{{
                        reasonRadio.title
                      }}</Typography>
                    </div>
                  </div>
                </template>
                <div
                  class="tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-shadow-2"
                >
                  <Typography variant="subtitle-1"
                    >Don't like current job title:
                    {{ candidate.current_job_title }}</Typography
                  >

                  <div
                    v-if="
                      candidate.other_bad_job_titles &&
                      candidate.other_bad_job_titles.length > 0
                    "
                  >
                    <Typography
                      variant="subtitle-1"
                      class="tw-flex tw-justify-between tw-items-center tw-mt-3"
                      >Exclude these job titles?
                      <v-btn
                        text
                        color="primaryDark"
                        @click="unselectAllJobTitles"
                      >
                        <span v-if="notSelectedAllJobTitles"> Select All </span>
                        <span v-else> Unselect All </span>
                      </v-btn>
                    </Typography>
                    <div class="tw-mt-3 tw-max-h-[200px] tw-overflow-auto">
                      <v-checkbox
                        v-for="(item, i) in candidate.other_bad_job_titles"
                        :key="i"
                        v-model="selection.bad_job_titles"
                        hide-details
                        :label="item"
                        :value="item"
                      ></v-checkbox>
                    </div>
                  </div>
                  <Typography v-else variant="body-2" class="tw-mt-3"
                    >Hirefly has no suggestions</Typography
                  >
                </div>
              </v-menu>
              <v-menu
                v-else-if="reasonRadio.key === '13'"
                bottom
                nudge-bottom="35px"
                :close-on-content-click="false"
                @input="onClickReasonRadio($event, reasonRadio.key)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="tw-flex tw-items-center tw-cursor-pointer">
                    <div>
                      <v-checkbox
                        v-model="selectedReason"
                        :value="reasonRadio.key"
                        hide-details
                      />
                    </div>
                    <div v-bind="attrs" v-on="on">
                      <Typography variant="body-2">{{
                        reasonRadio.title
                      }}</Typography>
                    </div>
                  </div>
                </template>
                <div
                  class="tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-shadow-2"
                >
                  <Typography
                    v-if="candidate.experiences && candidate.experiences[0]"
                    variant="subtitle-1"
                    >Don't like current company:
                    {{ candidate.experiences[0].company }}</Typography
                  >
                  <div
                    v-if="
                      candidate.other_bad_companies &&
                      candidate.other_bad_companies.length > 0
                    "
                  >
                    <Typography
                      variant="subtitle-1"
                      class="tw-flex tw-justify-between tw-items-center tw-mt-3"
                      >Exclude these companies?
                      <v-btn
                        text
                        color="primaryDark"
                        @click="unselectAllCompanies"
                      >
                        <span v-if="notSelectedAllCompanies"> Select All </span>
                        <span v-else> Unselect All </span>
                      </v-btn>
                    </Typography>
                    <div class="tw-mt-3 tw-max-h-[200px] tw-overflow-auto">
                      <v-checkbox
                        v-for="(item, i) in candidate.other_bad_companies"
                        :key="i"
                        v-model="selection.bad_companies"
                        hide-details
                        :label="item"
                        :value="item"
                      ></v-checkbox>
                    </div>
                  </div>
                  <Typography v-else variant="body-2" class="tw-mt-3"
                    >Hirefly has no suggestions</Typography
                  >
                </div>
              </v-menu>
              <div v-else class="tw-flex tw-items-center tw-cursor-pointer">
                <div>
                  <v-checkbox
                    v-model="selectedReason"
                    :value="reasonRadio.key"
                    hide-details
                  />
                </div>
                <div @click="onSelectReason(reasonRadio.key)">
                  <Typography variant="body-2">{{
                    reasonRadio.title
                  }}</Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-mt-4">
        <v-textarea
          ref="rejectionReason"
          v-model="rejection_reason_explanation"
          outlined
          no-resize
          class="radio-textarea"
          :placeholder="`Tell us more ${
            !(
              (selectedReason.includes('1') &&
                selection.bad_job_titles.length) ||
              (selectedReason.includes('13') && selection.bad_companies.length)
            )
              ? '(required)'
              : ''
          }`"
          hide-details="true"
          :rules="[rules.requiredExplanation]"
        >
        </v-textarea>
      </div>
      <div class="tw-flex tw-mt-6 tw-justify-between tw-items-center">
        <Button variant="text" @click="rejectReasonMenu = false">Cancel</Button>
        <Button :disabled="!isValid" variant="danger2" @click="reject">
          <div
            class="tw-flex tw-gap-3 tw-items-center tw-px-8 tw-justify-center tw-min-w-[210px] tw-text-base"
          >
            <div>
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="tw-stroke-white"
              >
                <path
                  d="M14.6665 1.66699V10.8337M18.8332 8.16699V4.33366C18.8332 3.40024 18.8332 2.93353 18.6516 2.57701C18.4918 2.2634 18.2368 2.00844 17.9232 1.84865C17.5667 1.66699 17.1 1.66699 16.1665 1.66699H7.26489C6.04699 1.66699 5.43804 1.66699 4.9462 1.88985C4.51271 2.08627 4.1443 2.40234 3.88425 2.80092C3.58919 3.25315 3.49659 3.85502 3.3114 5.05876L2.87551 7.8921C2.63125 9.47975 2.50912 10.2736 2.74472 10.8913C2.9515 11.4334 3.34042 11.8867 3.84482 12.1735C4.41949 12.5003 5.22266 12.5003 6.82899 12.5003H7.49988C7.96659 12.5003 8.19995 12.5003 8.37821 12.5912C8.53501 12.671 8.66249 12.7985 8.74239 12.9553C8.83321 13.1336 8.83321 13.3669 8.83321 13.8337V16.2788C8.83321 17.4137 9.75321 18.3337 10.8881 18.3337C11.1588 18.3337 11.4041 18.1742 11.514 17.9269L14.3146 11.6255C14.442 11.3389 14.5057 11.1956 14.6064 11.0905C14.6954 10.9976 14.8047 10.9266 14.9257 10.883C15.0626 10.8337 15.2194 10.8337 15.533 10.8337H16.1665C17.1 10.8337 17.5667 10.8337 17.9232 10.652C18.2368 10.4922 18.4918 10.2372 18.6516 9.92364C18.8332 9.56712 18.8332 9.10041 18.8332 8.16699Z"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div>Submit & reject</div>
          </div>
        </Button>
      </div>
    </div>
  </v-menu>
</template>
<script>
import Button from '@/components/v3/base/Button';
import DisLikeIcon from '@/assets/icons/dislike-icon.svg';
import Typography from '@/components/v3/base/Typography';
import SeniorityIcon from '@/assets/icons/seniority-icon.svg';
import ExperiencesIcon from '@/assets/icons/experience-icon.svg';
import EducationIcon from '@/assets/icons/education-icon.svg';
import AdditionalIcon from '@/assets/icons/additional-icon.svg';
import HotSpot from '../information-tours/HotSpot';
import FlashingButton from '../information-tours/FlashingButton';

export default {
  name: 'RejectedBox',
  components: {
    HotSpot,
    Button,
    FlashingButton,
    Typography,
  },

  props: {
    commentOnlyAccess: Boolean,
    candidate: {
      type: Object,
      default: () => {},
    },

    projectSetting: {
      type: Object,
      default: () => {},
    },

    projectId: String,
    isShowIntro2: Boolean,
    isShowIntro: Boolean,
    introStep: [String, Number],
    contents2: Array,
    contents: Array,
    isFront: Boolean,
    iscurrentGolive: Boolean,
    showFakeCard: Boolean,
    loading: Boolean,
    loadingAction: String,
  },

  data() {
    return {
      rejectReasonMenu: false,
      rejectedReasonStatus: false,
      selectedReason: [],
      reason_other: '',
      notSelectedAllJobTitles: true,
      notSelectedAllCompanies: true,
      isFlips: false,
      rejection_reason_explanation: '',
      reasonTypes: [
        {
          title: 'Seniority',
          reasons: [
            { title: 'Underqualified', key: '3', showIndex: false },
            { title: 'Overqualified', key: '5', showIndex: false },
          ],

          keys: ['3', '5'],
          icon: SeniorityIcon,
        },
        {
          title: 'Education',
          reasons: [
            { title: 'Want higher degrees', key: '9', showIndex: false },
            {
              title: 'Want more prestigious schools',
              key: '8',
              showIndex: false,
            },
          ],

          keys: ['9', '8'],
          icon: EducationIcon,
        },
        {
          title: 'Work Experience',
          reasons: [
            { title: "Don't like current job title", key: '1' },
            { title: "Don't like current company", key: '13' },
            { title: 'Missing necessary skills', key: '10', showIndex: false },
            {
              title: 'Background not in relevant industry',
              key: '15',
              showIndex: false,
            },
            // { title: 'Work history not relevant', key: '4' },
          ],

          keys: ['1', '13', '10', '15'],
          icon: ExperiencesIcon,
        },

        {
          title: 'Additional Considerations',
          reasons: [
            { title: 'Likely needs sponsorship', key: '14', showIndex: false },
            { title: 'Compensation too high  ', key: '7', showIndex: false },
            { title: 'Already Contacted', key: '12', showIndex: false },
            { title: 'Other', key: '11', showIndex: false },
          ],

          keys: ['14', '7', '12', '11'],
          icon: AdditionalIcon,
        },
      ],

      rules: {
        required: () => this.selectedReason.length > 0 || '',
        reasonText: (value) => {
          // console.log('In reason text validation');
          if (this.selectedReason.includes('11') && !value) {
            return 'This field is required.';
          }
          return true;
        },

        requiredExplanation: (value) => {
          if (
            (this.selectedReason.includes('1') &&
              this.selection.bad_job_titles.length) ||
            (this.selectedReason.includes('13') &&
              this.selection.bad_companies.length)
          ) {
            return true;
          }
          if (!value) {
            return 'This field is required.';
          }
          return true;
        },
      },

      selection: {
        bad_companies: [],
        keywords_required: [],
        bad_job_titles: [],
      },

      rejectionSubmitLoading: false,
      rejection_code: '',
      DisLikeIcon,
    };
  },

  computed: {
    isPilot() {
      return (
        this.projectSetting.in_auto_swipe_mode || // TODO(jeremiah): delete this line after v2 rollout
        this.projectSetting.type === '1'
      );
    },

    isValid() {
      if (
        (this.selectedReason.includes('1') &&
          this.selection.bad_job_titles.length) ||
        (this.selectedReason.includes('13') &&
          this.selection.bad_companies.length)
      ) {
        return true;
      }
      if (!this.rejection_reason_explanation) {
        return false;
      }
      return this.selectedReason.length > 0;
    },
  },

  watch: {
    isValid(val) {
      if (val) {
        this.$refs.rejectionReason?.resetValidation();
      }
    },
  },

  methods: {
    rejectAfterChanges() {
      this.$amplitude_client.logEvent({
        event_type: 'card_reject_fe',
        user_id: localStorage.getItem('email'),
        event_properties: {
          // eslint-disable-next-line no-underscore-dangle
          candidate_id: this.candidate._id,
          candidate_name: this.candidate.name,
          project_id: this.projectId,
          rejection_code: this.rejection_code,
          rejection_reason: this.selectedReason,
          rejection_reason_other: this.reason_other,
        },
      });

      this.rejectReasonMenu = false;
      this.status = 'rejected';
      this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
        candidate: this.candidate,
        field: 'processed',
        value: true,
      });
    },

    reject() {
      if (
        (this.selectedReason.includes('1') &&
          this.selection.bad_job_titles.length) ||
        (this.selectedReason.includes('13') &&
          this.selection.bad_companies.length) ||
        (this.selectedReason.includes('4') &&
          this.selection.keywords_required.length)
      ) {
        this.updateProject();
      }

      this.rejectAfterChanges();

      this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
        candidate: this.candidate,
        field: 'rejection_code',
        value: [...this.selectedReason],
      });
      const reason = {
        rejection_code: [...this.selectedReason],
        rejection_reason_other: this.reason_other,
      };
      // const notesArr = this.notes.filter((item) => !!item);
      // if (notesArr.length) {
      //   if (this.reason_other) notesArr.push(this.reason_other);
      //   reason.rejection_reason_other = notesArr.join(', ');
      // }
      if (this.rejection_reason_explanation) {
        reason.rejection_reason_other += `${
          reason.rejection_reason_other ? ', ' : ''
        }${this.rejection_reason_explanation}`;
      }
      this.$emit('reject', {
        candidateId: this.candidate._id,
        reason,
      });
      setTimeout(() => {
        this.$store.commit('projects/candidates/UPDATE_CANDIDATE', {
          candidate: this.candidate,
          field: 'rejection_reason_other',
          value: this.reason_other,
        });
      }, 500);
    },

    goBack() {
      this.rejectedReasonStatus = false;
    },

    checkMergedArr(arr1, arr2) {
      let result = false;
      arr1.forEach((item) => {
        if (arr2.includes(item)) {
          result = true;
        }
      });
      return result;
    },

    // TODO(jeremiah): make this go away in v2
    blurElement(e) {
      e.target.blur();
    },

    async updateProject() {
      try {
        this.rejectionSubmitLoading = true;
        const project = {};
        let badJobTitles = this.projectSetting.bad_job_titles || [];
        let badCompanies = this.projectSetting.bad_companies || [];
        let requiredKeywords = this.projectSetting.keywords_required || [];
        const selectedBadJobTitles = this.selection.bad_job_titles || [];

        if (this.selectedReason.includes('1')) {
          badJobTitles = [
            ...badJobTitles,
            ...selectedBadJobTitles,
            this.candidate.current_job_title,
          ];
          project.bad_job_titles = badJobTitles;
        }

        if (this.selectedReason.includes('13')) {
          const selectedBadCompanies = this.selection.bad_companies || [];
          const company =
            this.candidate.experiences && this.candidate.experiences[0]
              ? this.candidate.experiences[0].company
              : null;
          badCompanies = [...badCompanies, ...selectedBadCompanies];
          if (company) {
            badCompanies.push(company);
          }
          project.bad_companies = badCompanies;
        }

        if (this.selectedReason.includes('4')) {
          const selectedKeywordsRequired =
            this.selection.keywords_required || [];
          requiredKeywords = [...requiredKeywords, ...selectedKeywordsRequired];
          project.keywords_required = requiredKeywords;
        }
        project.should_populate = false;
        await this.$store.dispatch('projects/settings/updateProject', {
          projectId: this.projectId,
          project,
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.rejectionSubmitLoading = false;
      }
      // } else {
      //   this.reject();
      // }
    },

    unselectAllCompanies() {
      this.selection.bad_companies = this.candidate.other_bad_companies;
      this.notSelectedAllCompanies = !this.notSelectedAllCompanies;
      if (this.notSelectedAllCompanies) {
        this.selection.bad_companies = [];
      }
    },

    unselectAllJobTitles() {
      this.selection.bad_job_titles = this.candidate.other_bad_job_titles;
      this.notSelectedAllJobTitles = !this.notSelectedAllJobTitles;
      if (this.notSelectedAllJobTitles) {
        this.selection.bad_job_titles = [];
      }
    },

    onSelectReason(reason, defaultValue) {
      if (defaultValue) {
        this.selectedReason = this.selectedReason.filter(
          (item) => item !== reason
        );
        this.selectedReason.push(reason);
        return;
      }
      if (this.selectedReason.includes(reason)) {
        this.selectedReason = this.selectedReason.filter(
          (item) => item !== reason
        );
      } else {
        this.selectedReason.push(reason);
      }
    },

    async onClickReasonRadio(v, key) {
      if (v) {
        this.onSelectReason(key, true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/styles/card.scss';

.reason-box {
  overflow: hidden;
  display: flex;
  flex-flow: column;
  height: 100%;
  > div:nth-child(2) {
    overflow: auto;
    flex-grow: 8;
  }
}
.item-container {
  position: relative;
}
.note-rejection {
  border-radius: 8px;
  width: 100%;
  box-shadow: -1px 1px 12px rgba(0, 0, 0, 0.3) !important;
  z-index: 100;
  ::v-deep .v-card__title {
    font-weight: 500;
    color: #111827;
    font-size: 14px;
    text-align: center;
    display: block;
    padding: 12px;
    line-height: 1;
  }
  ::v-deep .v-label {
    font-size: 14px;
    color: #a1a5a6;
  }
  .skip-btn {
    border: none;
    font-size: 14px;
    text-transform: none;
  }
  .primary-btn {
    border: none;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    text-transform: none;
    background: #4646ab;
    border-radius: 4px;
  }
  ::v-deep .v-card__text {
    padding-bottom: 0px;
  }
}
.reject-reason-menu {
  top: 100px !important;
}
.rejection-note {
  margin-left: 26px;
}
.radio-textarea {
  &::v-deep textarea::placeholder {
    color: $placeholder;
    letter-spacing: 0;
    font-size: 14px;
    font-weight: 400;
  }
  &::v-deep textarea {
    font-size: 14px;
    height: 60px;
    padding-right: 5px !important;
    margin-bottom: 5px !important;
    line-height: 18px !important;
  }
  &::v-deep .v-text-field__slot {
    padding-right: 5px;
  }
}
.reason-box {
  ::v-deep .v-card__text {
    padding-top: 0px;
  }
  .unselectAllCompanies {
    margin-top: 0px;
  }
}
.w-custom-330 {
  width: 357px !important;
}
.other-reason {
  padding-left: 48px;
  padding-right: 20px;
  margin-top: -20px;
}
.reason-title {
  color: #111827;
  font-size: 14px;
}

::v-deep .v-input--radio-group__input > div {
  padding: 6px 16px;
}

.vertical-scroll {
  max-height: 385px;
  overflow-y: auto;
}
::v-deep {
  .v-card__title {
    word-break: break-word;
  }
  .v-label {
    font-size: 14px;
  }
  .v-input--selection-controls {
    margin-top: 0px;
  }
  .v-input--selection-controls__ripple {
    height: 25px;
    width: 25px;
    left: 0px;
    top: 0px;
    margin: 0px;
  }
}
.go-back-icon {
  top: 7px !important;
  left: 5px !important;
}
.sub-checklist {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-left: -2px;
  &::v-deep .v-label {
    font-size: 12px;
    color: #111827;
    line-height: 14px;
  }
}

.flip-box {
  background-color: transparent;
  width: 414px;
  height: 546px;
  perspective: 1000px; /* Remove this if you don't want the 3D effect */
}

/* This container is needed to position the front and back side */
.flip-box-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.3s;
  transform-style: preserve-3d;
}

/* Do an horizontal flip when you move the mouse over the flip box container */
.flip-box.active .flip-box-inner {
  transform: rotateY(180deg);
}

/* Position the front and back side */
.flip-box-front,
.flip-box-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  overflow: visible;
}
.flip-box-front {
  z-index: 2;
}
.flip-box-back {
  transform: rotateY(180deg);
  z-index: 1;
}
/* Style the front side (fallback if image is missing) */
.flip-box.active .flip-box-back {
  z-index: 3;
}

/* Style the back side */
.rejection-section {
  width: 640px;
  .flip-box-back,
  .flip-box-front {
    box-shadow: -1px 0px 12px 0px rgb(0, 0, 0, 0.5);
    border-radius: 20px;
    overflow: hidden;
  }
}
.grid-col-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.rejected-flashing {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 0);
}
.overlay2 {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 1;
  border-radius: 20px;
  top: 0px;
  left: -3px;
  width: calc(100% + 6px);
  height: calc(100% + 0px);
}
.z-10 {
  z-index: 10;
}
</style>
